// Import stylów Bootstrap (CSS framework dla wyglądu)
import 'bootstrap/dist/css/bootstrap.css'

// Style kalendarza (@vuepic/vue-datepicker). Ładowane TU, a nie w komponentach —
// przy imporcie z komponentu style-loader wstrzykuje je dopiero przy leniwym
// załadowaniu widoku, czyli PO naszym arkuszu, i biblioteka wygrywała kolejnością
// z nadpisaniami w `design-system.css` (inny wygląd w `npm run serve` niż w buildzie).
import '@vuepic/vue-datepicker/dist/main.css'

// Wspólny język wizualny aplikacji — tokeny (kolory, odstępy, typografia, metryki
// kontrolek) oraz style paneli, tabel i kontrolek formularza. Ładowane PO bootstrapie
// i po stylach bibliotek, żeby je nadpisywały. Kolejność ma znaczenie:
// design-system → button-system (przyciski korzystają z tokenów) → viver-style (reszta).
import './assets/css/design-system.css'
import './assets/css/button-system.css'
import './assets/css/viver-style.css'

// Import podstawowych funkcji Vue 3
import { createApp } from 'vue'

// Import Pinia (store zarządzający stanem aplikacji)
import { createPinia } from 'pinia'

// Import głównego komponentu aplikacji
import CarViver from './CarViver.vue'

// Import routera (obsługa tras/ścieżek)
import router from './router'

// Import biblioteki i18n do tłumaczeń
import { createI18n } from 'vue-i18n'

// Import plików z tłumaczeniami dla poszczególnych języków
import en from './locales/en.json'
import pl from './locales/pl.json'
import lt from './locales/lt.json'
import de from './locales/de.json'
import ro from './locales/ro.json'
import ua from './locales/ua.json'

// Słownik wartości pochodzących z bazy danych (opisy ról, tytuły zgłoszeń itp.).
// Ładowany pod przestrzeń nazw `db` — klucze liczone z treści zdania (`helpers/dbKey.js`),
// dostęp przez `tdb()` (`helpers/dbTranslate.js`).
import dbEn from './locales/db/en.json'
import dbPl from './locales/db/pl.json'
import dbLt from './locales/db/lt.json'
import dbDe from './locales/db/de.json'
import dbRo from './locales/db/ro.json'
import dbUa from './locales/db/ua.json'
import { tdb } from './helpers/dbTranslate'
import { isSG } from './config/appVersion'
import { useAuthStore } from './stores/auth.store'

if (!isSG) {
  const fontLink = document.createElement('link')
  fontLink.rel = 'stylesheet'
  fontLink.type = 'text/css'
  fontLink.href = 'https://fonts.googleapis.com/css?family=Ubuntu:regular,bold&subset=Latin'
  document.head.appendChild(fontLink)
}

// Tworzymy instancję Pinia (globalny store)
const pinia = createPinia()

// Pobieramy język zapisany w localStorage, domyślnie 'pl'
const savedLang = localStorage.getItem('lang') || 'pl';

// Tworzymy instancję i18n z tłumaczeniami
const i18n = createI18n({
  legacy: false,                 // Nowy sposób korzystania (Composition API)
  locale: savedLang,             // Aktualny język
  fallbackLocale: 'pl',          // Język zapasowy, jeśli czegoś nie przetłumaczono
  messages: {
    pl: { ...pl, db: dbPl },
    en: { ...en, db: dbEn },
    lt: { ...lt, db: dbLt },
    de: { ...de, db: dbDe },
    ro: { ...ro, db: dbRo },
    ua: { ...ua, db: dbUa },
  },
})

// Tworzymy instancję aplikacji Vue na podstawie komponentu CarViver
const app = createApp(CarViver)

// Dodajemy Pinia (store) do aplikacji
app.use(pinia)

// Dodajemy router (nawigacja po widokach) do aplikacji
app.use(router)

// Dodajemy tłumaczenia i18n do aplikacji
app.use(i18n)

// Shortcut – pozwala używać this.t('klucz') w komponentach Options API
app.config.globalProperties.t = i18n.global.t

// Shortcut – `this.tdb('tekst z bazy')` tłumaczy wartości słownikowe zapisane w bazie
// (np. opisy ról). Brak wpisu w słowniku = zwracany oryginał, więc widok nigdy nie pustoszeje.
app.config.globalProperties.tdb = tdb

// Montujemy aplikację do elementu o id #app (w index.html)
app.mount('#app')

// Po przeładowaniu strony (F5) wznów sesję: jeśli token jest w sessionStorage, odtwórz
// nasłuch aktywności i utrzymywanie sesji. W wersjach nieprodukcyjnych (test / lokalny dev)
// sesja BE przeżywa reload (sendLeaveRequest jest pomijane), więc użytkownik pozostaje zalogowany.
useAuthStore().rehydrateSession()

// Eksportujemy i18n (przydatne np. w store Pinia)
export { i18n }
